"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconDiagramWaveBothDirection = /*#__PURE__*/
function (_Icon) {
  _inherits(IconDiagramWaveBothDirection, _Icon);
  function IconDiagramWaveBothDirection(props) {
    var _this;
    _classCallCheck(this, IconDiagramWaveBothDirection);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconDiagramWaveBothDirection).call(this, props));
    _this.name = 'IconDiagramWaveBothDirection';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "diagram-wave-both-direction_svg__group0"
    }, _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path0",
      d: "M3.5 23.5a.5.5 0 01-.354-.146l-3-3a.5.5 0 010-.708l3-3a.501.501 0 01.708.708L1.707 19.5h.914a.5.5 0 010 1h-.914l2.146 2.146a.5.5 0 01-.353.854z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path1",
      d: "M20.5 7.5a.5.5 0 01-.354-.854L22.293 4.5h-.813a.5.5 0 010-1h.813l-2.146-2.146a.5.5 0 11.707-.708l2.937 2.936a.496.496 0 01-.001.835l-2.937 2.936a.494.494 0 01-.353.147z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path2",
      d: "M17.48 4.5a.5.5 0 010-1h2.04a.5.5 0 010 1h-2.04z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path3",
      d: "M13.48 4.5a.5.5 0 010-1h2.04a.5.5 0 010 1h-2.04z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path4",
      d: "M9.49 4.628a.501.501 0 01-.414-.78.493.493 0 01.32-.21 8.56 8.56 0 012.154-.136.5.5 0 01-.031.998l-.032-.001a7.637 7.637 0 00-1.903.12.499.499 0 01-.094.009z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path5",
      d: "M6.7 7.262a.493.493 0 01-.445-.273.5.5 0 01-.03-.381 4.526 4.526 0 011.219-1.911.5.5 0 11.68.732c-.436.406-.764.92-.948 1.487a.5.5 0 01-.476.346z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path6",
      d: "M7.406 11.032a.501.501 0 01-.387-.183 4.503 4.503 0 01-.95-2.061.497.497 0 01.406-.58.5.5 0 01.58.404c.105.587.36 1.141.738 1.603a.495.495 0 01.111.366.496.496 0 01-.498.451z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path7",
      d: "M10.638 12.512c-.628 0-1.268-.12-1.85-.346a.5.5 0 01.362-.932 4.144 4.144 0 001.782.267l.041-.002a.5.5 0 01.032.999c-.122.01-.244.014-.367.014z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path8",
      d: "M14.939 12.766a.502.502 0 01-.167-.029 4.382 4.382 0 00-1.801-.239l-.039.001a.501.501 0 01-.038-.999 5.375 5.375 0 012.212.293.5.5 0 01-.167.973z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path9",
      d: "M17.42 15.7a.503.503 0 01-.49-.4 3.511 3.511 0 00-.78-1.586.496.496 0 01.052-.705.5.5 0 01.706.053 4.515 4.515 0 011.002 2.039.497.497 0 01-.49.599z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path10",
      d: "M16.289 19.367a.503.503 0 01-.5-.507.5.5 0 01.151-.351c.428-.416.745-.938.916-1.51a.504.504 0 01.622-.336.499.499 0 01.336.622 4.505 4.505 0 01-1.177 1.94.492.492 0 01-.348.142z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path11",
      d: "M13.073 20.518c-.175 0-.352-.006-.527-.019a.501.501 0 01.031-.998l.045.002a6.447 6.447 0 001.875-.144.504.504 0 01.599.376.495.495 0 01-.376.598 7.5 7.5 0 01-1.647.185z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path12",
      d: "M8.581 20.5a.5.5 0 010-1h2.04a.5.5 0 010 1h-2.04z"
    }), _react2.default.createElement("path", {
      className: "diagram-wave-both-direction_svg__path13",
      d: "M4.581 20.5a.5.5 0 010-1h2.04a.5.5 0 010 1h-2.04z"
    })));
    return _this;
  }
  return IconDiagramWaveBothDirection;
}(_Icon3.default);
exports.default = IconDiagramWaveBothDirection;